<template>
    <div class="cart__item rounded-0">
        {{ name }} <a @click="removeFromCart()"><i class="fa fa-trash" aria-hidden="true"></i></a>
        <!-- remove btn hierboven komt niet door -->
        <i class="far fa-trash-alt" aria-hidden="true"></i>
    </div>
</template>

<script>
    import ajax from '../../ajax';

    export default {
        props: ['item'],

        data() {
          return {
              id: null,
              name: null
          }
        },
        methods: {
            removeFromCart() {
                let products    = JSON.parse(localStorage.getItem("products"));
                let index       = products.findIndex(product => product.id === this.$data.id);
                products.splice(index, 1);
                localStorage.setItem('products', JSON.stringify(products));
                this.$root.$emit('fetch-cart-items');
            }
        },
        mounted () {

            this.$on('save-product', data => {
                // Add the product with the answers to the array
                this.$data.products.push({
                    id      : data.product,
                    answers : data.answers
                });
                localStorage.setItem('products', JSON.stringify(this.$data.products));
            });

            let productID = this.item.id;

            ajax
                .get('/api/v1/product/'+ productID)
                    .then(response =>{
                        if(response.status === 200) {
                            this.id     = response.data.id,
                            this.name   = response.data.name
                        }
                    })
                    .catch(error =>{
                        console.log(error);
                    })
        }
    }
</script>

<style scoped lang="scss">
    .cart__item {
        padding: 1em 2em;
        border-bottom: 1px solid #716f6f;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        color: #716f6f;
        a{
            cursor: pointer;
            color: #716f6f !important;
            &:hover{
                opacity: .8;
            }
        }
    }

</style>